import { Application } from "stimulus";
import LottieController from "../../controllers_v2/lottie_controller";
import editorialContentController from "../../controllers_v2/editorial_content_controller";

const application = Application.start();
application.register("lottie", LottieController);
